import React from "react";
import logo from "../../../assets/images/logotalent.png";

export default function LoginSlide({ progress }) {
  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ height: "100%" }}
    >
      <div
        className="card shadow p-4 d-flex align-items-center  "
        style={{ backgroundColor: "rgba(255, 255, 255, 0.5)" }}
      >
        <img
          src={logo}
          alt="Loading..."
          style={{
            width: "250px",
          }}
        />
        <div className="progress w-100 mt-4">
          <div
            style={{
              height: "100%",
              width: `${progress}%`,
              backgroundColor: "var(--portal-primary-color)",
              transition: "width 0.1s linear",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
}
